import React from "react";
import Workflow from "./components/workflow";

const WorkflowUpdate = () => {
  return <Workflow />;
};

WorkflowUpdate.auth = {
  path: "/workflows/update",
  role: "super-admin admin",
};

export default WorkflowUpdate;
